import { PropsWithChildren, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { AdvancedTooltip } from 'common-components'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { OVERLAY_MAX_WIDTH } from 'consts/sidebar'
import { isVideoConsistencyFeatureAvailableSelector } from 'store/selectors'
import * as Styled from './styled'

export const DisabledWrapper = ({ children }: PropsWithChildren) => {
  const isConsistencyFeatureAvailable = useSelector(
    isVideoConsistencyFeatureAvailableSelector
  )
  const isConsistencyEnabled = useSelector(
    aiVideoSelectors.isConsistencyEnabled
  )
  const [wrapperRef, setWrapperRef] = useState<HTMLDivElement | null>(null)

  const isDisabled = useMemo(
    () => isConsistencyFeatureAvailable && isConsistencyEnabled,
    [isConsistencyFeatureAvailable, isConsistencyEnabled]
  )

  return (
    <Styled.DisabledContainer $disabled={isDisabled} ref={setWrapperRef}>
      {isDisabled ? (
        <AdvancedTooltip
          tooltipText={translate(T.CONSISTENCY_DISABLED_FIELD_TOOLTIP)}
          btnRef={{ current: wrapperRef }}
          showMobileTooltip
          isToggledByClick={false}
          maxWidth={OVERLAY_MAX_WIDTH}
        />
      ) : null}
      {children}
    </Styled.DisabledContainer>
  )
}
